/* DustyMama motion: reveals, word/letter splits, scroll-driven puzzle, kinetic text, stacked slides, horizontal gallery, hero video. No libraries. */
(function () {
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = mqReduce.matches;
  var motion = 'IntersectionObserver' in window && !reduce;
  var drivers = [];
  var ticking = false;
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function run() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = drivers.length - 1; i >= 0; i--) {
      if (!document.documentElement.contains(drivers[i].el)) { drivers.splice(i, 1); continue; }
      drivers[i].fn(vh);
    }
  }
  function requestRun() { if (!ticking) { ticking = true; requestAnimationFrame(run); } }
  window.addEventListener('scroll', requestRun, { passive: true });
  window.addEventListener('resize', requestRun);
  window.addEventListener('load', requestRun);

  function rnd(n) { var x = Math.sin(n * 12.9898 + 78.233) * 43758.5453; return x - Math.floor(x); }
  function splitWords(el) {
    var fx = el.dataset.dmFx || 'rise';
    var words = el.textContent.trim().split(/\s+/), ci = 0;
    el.setAttribute('aria-label', el.textContent.trim());
    el.textContent = '';
    words.forEach(function (w, i) {
      var o = document.createElement('span'); o.className = 'dm-w'; o.setAttribute('aria-hidden', 'true');
      o.style.setProperty('--i', i); o.style.setProperty('--dir', i % 2 ? 1 : -1);
      var s = document.createElement('span'); s.style.setProperty('--i', i);
      if (fx === 'scatter') {
        Array.prototype.forEach.call(w, function (ch) {
          var c = document.createElement('span'); c.className = 'dm-c'; c.textContent = ch;
          c.style.setProperty('--i', ci);
          c.style.setProperty('--x', Math.round((rnd(ci + 1) - 0.5) * 900) + 'px');
          c.style.setProperty('--y', Math.round((rnd(ci + 31) - 0.5) * 560) + 'px');
          c.style.setProperty('--r', Math.round((rnd(ci + 67) - 0.5) * 220) + 'deg');
          s.appendChild(c); ci++;
        });
      } else { s.textContent = w; }
      o.appendChild(s); el.appendChild(o); el.appendChild(document.createTextNode(' '));
    });
    if (!el.hasAttribute('data-dm')) el.setAttribute('data-dm', 'words');
  }
  function splitChars(el) {
    var text = el.textContent.trim();
    el.setAttribute('aria-label', text); el.textContent = '';
    Array.prototype.forEach.call(text, function (c, i) {
      var o = document.createElement('span'); o.className = 'dm-ch'; o.setAttribute('aria-hidden', 'true');
      var s = document.createElement('span'); s.textContent = c === ' ' ? ' ' : c; s.style.setProperty('--i', i);
      s.style.setProperty('--y', i % 2 ? '112%' : '-112%'); s.style.setProperty('--r', (i % 2 ? 12 : -12) + 'deg');
      o.appendChild(s); el.appendChild(o);
    });
    if (!el.hasAttribute('data-dm')) el.setAttribute('data-dm', 'chars');
  }

  function heroVideo(v) {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var ua = navigator.userAgent || '';
    var appleWebKit = /iPhone|iPad|iPod/.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Android|Firefox/.test(ua));
    var hlsOk = appleWebKit && !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
    var mp4 = (mobile && v.dataset.mobile) || v.dataset.desktop || v.dataset.mobile;
    var src = (mobile && v.dataset.mobile) || v.dataset.desktop || v.dataset.mobile;
    var hls = (mobile && v.dataset.mobileHls) || v.dataset.desktopHls || v.dataset.mobileHls;
    if (hlsOk && hls) src = hls; /* iPhone/Safari: flux adaptiv, pornește repede și pe date mobile */
    var saveData = navigator.connection && navigator.connection.saveData;
    if (!src || saveData) return;           /* poster stays as the fallback */
    v.muted = true; v.defaultMuted = true; v.autoplay = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('autoplay', '');
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    v.addEventListener('error', function () { v.classList.remove('is-playing'); });
    v.src = src;
    if (src !== mp4 && mp4) { /* dacă fluxul adaptiv nu pornește, trece pe mp4 */
      var fell = false;
      var fallback = function () { if (fell || v.classList.contains('is-playing')) return; fell = true; v.src = mp4; tryPlay(); };
      v.addEventListener('error', fallback, { once: true });
      setTimeout(fallback, 5000);
    }
    function tryPlay() { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
    tryPlay();
    /* iPhone (mod economie baterie) sau browsere stricte: pornește la prima atingere/derulare */
    function kick() { if (v.paused) tryPlay(); }
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (ev) { window.addEventListener(ev, kick, { passive: true, once: true }); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) kick(); else if (!v.paused) v.pause(); }); }, { threshold: 0.05 }).observe(v);
  }

  function kinetic(el) {
    var raw = el.textContent.trim(), em = false, n = 0;
    el.setAttribute('aria-label', raw.replace(/\*/g, '')); el.textContent = '';
    raw.split(/\s+/).forEach(function (tok) {
      var starts = tok.charAt(0) === '*'; if (starts) { em = true; tok = tok.slice(1); }
      var endAt = tok.indexOf('*'), tail = '';
      var word = tok; var closes = false;
      if (endAt > -1) { word = tok.slice(0, endAt); tail = tok.slice(endAt + 1); closes = true; }
      var s = document.createElement('span'); s.textContent = word + tail; s.setAttribute('aria-hidden', 'true');
      if (em) s.className = 'is-em';
      var ang = rnd(n + 5) * Math.PI * 2, dist = 160 + rnd(n + 11) * 260;
      s.style.setProperty('--x', Math.round(Math.cos(ang) * dist) + 'px'); s.style.setProperty('--y', Math.round(Math.sin(ang) * dist * 0.6) + 'px');
      s.style.setProperty('--r', Math.round((rnd(n + 23) - 0.5) * 60) + 'deg');
      if (closes) em = false;
      el.appendChild(s); el.appendChild(document.createTextNode(' ')); n++;
    });
    var spans = el.querySelectorAll('span');
    if (!motion) return;
    drivers.push({ el: el, fn: function (vh) {
      var r = el.getBoundingClientRect();
      var p = clamp((vh * 0.82 - r.top) / (r.height + vh * 0.34));
      var lit = Math.round(p * (n + 1));
      for (var i = 0; i < spans.length; i++) spans[i].classList.toggle('is-lit', i < lit);
    } });
  }

  function puzzle(grid) {
    var pieces = grid.querySelectorAll('[data-dm-piece]');
    if (!motion) return;
    Array.prototype.forEach.call(pieces, function (li, i) {
      li.style.setProperty('--p', 0);
      drivers.push({ el: li, fn: function (vh) {
        var r = li.getBoundingClientRect();
        var p = clamp((vh * 1.02 - r.top - (i % 4) * 26) / (vh * 0.5));
        li.style.setProperty('--p', ease(p).toFixed(3));
      } });
    });
  }

  function slides(list) {
    var items = list.querySelectorAll('.dm-slide');
    Array.prototype.forEach.call(items, function (s, i) { s.style.setProperty('--i', i); });
    if (!motion) return;
    drivers.push({ el: list, fn: function () {
      for (var i = 0; i < items.length - 1; i++) {
        var a = items[i].getBoundingClientRect(), b = items[i + 1].getBoundingClientRect();
        var p = clamp(1 - (b.top - a.top) / a.height);
        items[i].style.setProperty('--s', (1 - p * 0.06).toFixed(4));
      }
    } });
    Array.prototype.forEach.call(list.querySelectorAll('video'), function (v) {
      v.muted = true;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
      }, { threshold: 0.3 }).observe(v);
    });
  }

  function gallery(g) {
    var track = g.querySelector('.dm-gal__track'), bar = g.querySelector('.dm-gal__bar');
    if (!track) return;
    var desktop = window.matchMedia('(min-width: 750px)');
    var runLen = 0;
    function measure() {
      var pin = motion && desktop.matches;
      g.classList.toggle('is-pinned', pin);
      if (!pin) { g.style.height = ''; track.style.transform = ''; return; }
      track.style.transform = '';
      runLen = Math.max(0, track.scrollWidth - g.clientWidth);
      g.style.height = 'calc(100vh + ' + Math.round(runLen) + 'px)';
      requestRun();
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (im) { if (!im.complete) im.addEventListener('load', measure); });
    drivers.push({ el: g, fn: function (vh) {
      if (g.classList.contains('is-pinned')) {
        var r = g.getBoundingClientRect();
        var p = clamp(-r.top / Math.max(1, r.height - vh));
        track.style.transform = 'translate3d(' + (-runLen * p).toFixed(1) + 'px,0,0)';
        if (bar) bar.style.setProperty('--gp', Math.max(0.06, p).toFixed(3));
      }
    } });
    track.addEventListener('scroll', function () {
      if (bar && !g.classList.contains('is-pinned')) {
        var m = track.scrollWidth - track.clientWidth;
        bar.style.setProperty('--gp', Math.max(0.06, m ? track.scrollLeft / m : 1).toFixed(3));
      }
    }, { passive: true });
  }

  function parallax(el) {
    var k = parseFloat(el.dataset.dmPar) || 0.1;
    drivers.push({ el: el, fn: function (vh) {
      var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var q = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.setProperty('--py', (q * k * -100).toFixed(1) + 'px'); el.style.setProperty('--pr', q.toFixed(3));
    } });
  }

  function heroFx(el) {
    if (!motion) return;
    drivers.push({ el: el, fn: function () {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--hp', clamp(-r.top / Math.max(1, r.height)).toFixed(3));
    } });
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
        el.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
      });
    }
  }
  function drift(el) {
    var k = parseFloat(el.dataset.dmDrift) || 1;
    drivers.push({ el: el, fn: function (vh) {
      var r = el.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var p = clamp((vh - r.top) / (vh + r.height));
      el.style.setProperty('--dx', (-p * 34 * k).toFixed(2) + 'vw');
    } });
  }
  function tilt(card) {
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.style.setProperty('--ry', ((x - 0.5) * 14).toFixed(2) + 'deg'); card.style.setProperty('--rx', ((0.5 - y) * 14).toFixed(2) + 'deg');
      card.style.setProperty('--gx', Math.round(x * 100) + '%'); card.style.setProperty('--gy', Math.round(y * 100) + '%');
    });
    card.addEventListener('pointerleave', function () { card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg'); });
  }
  function counter(el) {
    var to = parseFloat(el.dataset.to) || 0, from = parseFloat(el.dataset.from) || 0;
    if (!motion) { el.textContent = to; return; }
    el.textContent = from;
    new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var t0 = null, dur = 1800;
      function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(from + (to - from) * ease(k)); if (k < 1) requestAnimationFrame(f); }
      requestAnimationFrame(f);
    }, { threshold: 0.6 }).observe(el);
  }
  var chromeDone = false;
  function chrome() {
    if (chromeDone || !motion) return; chromeDone = true;
    var opt = window.dmOptions || {};
    if (opt.progress !== false) {
      var bar = document.createElement('div'); bar.className = 'dm-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
      drivers.push({ el: bar, fn: function (vh) {
        var max = document.documentElement.scrollHeight - vh;
        bar.style.setProperty('--sp', max > 0 ? clamp(window.scrollY / max).toFixed(4) : 0);
      } });
    }
    if (opt.cursor !== false && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var cur = document.createElement('div'); cur.className = 'dm-cursor'; cur.setAttribute('aria-hidden', 'true'); document.body.appendChild(cur);
      var tx = -100, ty = -100, x = -100, y = -100, s = 1, ts = 1, raf = null;
      function loop() {
        x += (tx - x) * 0.22; y += (ty - y) * 0.22; s += (ts - s) * 0.18;
        cur.style.setProperty('--cx', x.toFixed(1) + 'px'); cur.style.setProperty('--cy', y.toFixed(1) + 'px'); cur.style.setProperty('--cs', s.toFixed(3));
        raf = (Math.abs(tx - x) + Math.abs(ty - y) + Math.abs(ts - s) > 0.05) ? requestAnimationFrame(loop) : null;
      }
      document.addEventListener('pointermove', function (e) {
        tx = e.clientX; ty = e.clientY;
        var inDm = e.target.closest && e.target.closest('.dm');
        cur.classList.toggle('is-on', !!inDm);
        ts = inDm && e.target.closest('a,button,.dm-card,.dm-gal__item') ? 4.2 : 1;
        if (!raf) raf = requestAnimationFrame(loop);
      }, { passive: true });
    }
  }

  function init(root) {
    if (!root || root.dataset.dmReady) return;
    root.dataset.dmReady = '1';
    var savedMotion = motion; if (root.classList.contains('dm-noanim')) motion = false;
    if (motion) root.classList.add('dm-js');
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-split]'), splitWords);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-chars]'), splitChars);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-kinetic]'), kinetic);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-puzzle]'), puzzle);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-slides]'), slides);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-gallery]'), gallery);
    Array.prototype.forEach.call(root.querySelectorAll('video[data-dm-hero-video]'), heroVideo);
    if (motion) Array.prototype.forEach.call(root.querySelectorAll('[data-dm-par]'), parallax);
    if (motion) Array.prototype.forEach.call(root.querySelectorAll('[data-dm-drift]'), drift);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dm-count]'), counter);
    Array.prototype.forEach.call(root.querySelectorAll('video[data-dm-autoplay]'), function (v) {
      v.muted = true;
      if (!('IntersectionObserver' in window) || reduce) return;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
      }, { threshold: 0.35 }).observe(v);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.dm-hero'), heroFx);
    if (motion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) Array.prototype.forEach.call(root.querySelectorAll('.dm-card'), tilt);
    chrome();

    var items = root.querySelectorAll('[data-dm]');
    var list = Array.prototype.slice.call(items);
    var hero = root.querySelector('.dm-hero'); if (hero) list.push(hero);
    if (motion) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
      list.forEach(function (el) { io.observe(el); });
    } else {
      list.forEach(function (el) { el.classList.add('is-in'); });
    }
    motion = savedMotion;
    requestRun();
  }

  /* product-page bundle picker: drives Dawn's own (hidden) variant picker */
  function bundle(el) {
    if (el.dataset.dmReady) return; el.dataset.dmReady = '1';
    var sid = el.dataset.section;
    el.addEventListener('click', function (e) {
      var opt = e.target.closest('.dm-bundle__opt'); if (!opt || opt.disabled) return;
      var picker = document.getElementById('variant-selects-' + sid); if (!picker) return;
      var id = opt.dataset.valueId;
      var input = picker.querySelector('input[data-option-value-id="' + id + '"]');
      if (input) { if (!input.checked) input.click(); }
      else {
        var o = picker.querySelector('option[data-option-value-id="' + id + '"]');
        if (o) { o.selected = true; o.parentNode.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      Array.prototype.forEach.call(el.querySelectorAll('.dm-bundle__opt'), function (b) {
        var on = b === opt; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });
  }
  /* visual bundle selector */
  function offer(el) {
    if (el.dataset.dmReady) return; el.dataset.dmReady = '1';
    var opts = el.querySelectorAll('.dm-ofx__opt'), pack = el.querySelector('.dm-pack'), stage = el.querySelector('.dm-ofx__stage');
    function out(k) { return el.querySelector('[data-out="' + k + '"]'); }
    function set(o, user) {
      if (!o || o.disabled) return;
      Array.prototype.forEach.call(opts, function (b) { var on = b === o; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var d = o.dataset;
      if (pack) pack.setAttribute('data-q', d.q);
      if (stage) stage.style.setProperty('--q', d.q);
      [['price', d.price], ['full', d.full], ['save', d.save], ['pct', d.pct], ['units', d.units], ['ship', d.ship]].forEach(function (p) { var n = out(p[0]); if (n) n.textContent = p[1] || ''; });
      var f = out('fill'); if (f) f.style.setProperty('--f', (parseFloat(d.fill) || 0) / 100);
      el.classList.toggle('is-free', o.classList.contains('is-free'));
      if (user && !reduce) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      if (el.dataset.mode === 'home') {
        var inp = el.querySelector('input[name="id"]'); if (inp && d.vid) inp.value = d.vid;
      } else if (user) {
        var picker = document.getElementById('variant-selects-' + el.dataset.section); if (!picker) return;
        var input = picker.querySelector('input[data-option-value-id="' + d.valueId + '"]');
        if (input) { if (!input.checked) input.click(); }
        else {
          var op = picker.querySelector('option[data-option-value-id="' + d.valueId + '"]');
          if (op) { op.selected = true; op.parentNode.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
    }
    el.addEventListener('click', function (e) { var o = e.target.closest('.dm-ofx__opt'); if (o) set(o, true); });
    set(el.querySelector('.dm-ofx__opt.is-on') || opts[0], false);
  }
  function bootBundles(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dm-offer]'), offer); Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dm-bundle]'), bundle); }

  function boot(scope) { bootBundles(scope); Array.prototype.forEach.call((scope || document).querySelectorAll('.dm'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
